export const frameworkPermissions = (actions: Set<string>) => {
  const MANAGE_FRAMEWORK = actions.has('manage-framework')
  const EDIT_FRAMEWORK = actions.has('edit-framework')
  const VIEW_FRAMEWORK_WORKLIST = actions.has('view-framework-worklist')
  const ACCEPT_FRAMEWORK_WORKLIST = actions.has('accept-framework-worklist')
  const REJECT_FRAMEWORK_WORKLIST = actions.has('reject-framework-worklist')
  const VIEW_FRAMEWORK = actions.has('view-framework')
  const CREATE_SNMS_DRAFT = actions.has('create-snms-draft')
  const CREATE_ACTION_PLAN = actions.has('create-action-plan')
  const VIEW_ACTION_PLAN = actions.has('view-action-plan')
  const VIEW_ALL_ACTION_PLANS = actions.has('view-all-action-plans')
  const DELETE_ACTION_PLAN = actions.has('delete-action-plan')
  const EDIT_ACTION_PLAN = actions.has('edit-action-plan')

  return {
    ACCEPT_FRAMEWORK_WORKLIST,
    CREATE_ACTION_PLAN,
    CREATE_SNMS_DRAFT,
    DELETE_ACTION_PLAN,
    EDIT_ACTION_PLAN,
    EDIT_FRAMEWORK,
    MANAGE_FRAMEWORK,
    REJECT_FRAMEWORK_WORKLIST,
    VIEW_ACTION_PLAN,
    VIEW_ALL_ACTION_PLANS,
    VIEW_FRAMEWORK,
    VIEW_FRAMEWORK_WORKLIST,
  }
}
